import { lazy, Suspense } from "react";
import CircularLoader from "../../custom/circularLoader/circularLoader";
import DashboardLayout from "../dashboardLayout/dashboardLayout";

const Main = lazy(() => import("../../components/previewPage/main"));

const NyscPreviewPage = () => {
    return (
        <DashboardLayout 
            heading="Application Form"
            paragraph="Preview details" 
        >
            <Suspense fallback={<CircularLoader/>}>
                <Main/>
            </Suspense>
        </DashboardLayout>
    )
}
export default NyscPreviewPage;